import { render } from "./SettingsApp.vue?vue&type=template&id=175a0c40"
import script from "./SettingsApp.vue?vue&type=script&lang=js"
export * from "./SettingsApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__